export function calcularDiasUteisComHoras(inicio, fim) {
    if (fim.isBefore(inicio)) return 0

    const isWeekday = m => m.day() !== 0 && m.day() !== 6

    const inicioDia = inicio.clone().startOf('day')
    const fimDia = fim.clone().startOf('day')

    if (inicioDia.isSame(fimDia)) {
        return isWeekday(inicio) ? fim.diff(inicio, 'hours', true) / 24 : 0
    }

    let count = 0

    if (isWeekday(inicio)) {
        const inicioProximoDia = inicio.clone().add(1, 'day').startOf('day')
        count += inicioProximoDia.diff(inicio, 'hours', true) / 24
    }

    let cursor = inicioDia.clone().add(1, 'day')
    while (cursor.isBefore(fimDia, 'day')) {
        if (isWeekday(cursor)) count += 1
        cursor.add(1, 'day')
    }

    if (isWeekday(fim)) {
        const fimInicioDia = fim.clone().startOf('day')
        count += fim.diff(fimInicioDia, 'hours', true) / 24
    }

    return count
}
